import type { OverviewCustomRange, OverviewPeriod } from './types'

export interface PeriodWindow {
  from: string // YYYY-MM-DD
  to: string   // YYYY-MM-DD
}

function isoDate(d: Date): string {
  return d.toISOString().slice(0, 10)
}

/**
 * Mirror of the period-window math in `backend/routes/dashboard.js`.
 * Given the dashboard period selector + (optionally) a custom range +
 * the tenant's fiscal-year start month, return the {from, to} pair the
 * AR / AP / Budget summary endpoints should filter by so every section
 * on the dashboard reflects the same window.
 */
export function resolvePeriodWindow(
  period: OverviewPeriod,
  custom?: OverviewCustomRange,
  fiscalStartMonth?: number,
): PeriodWindow {
  const today = new Date()
  if (period === 'CUSTOM' && custom?.from && custom?.to) {
    return { from: custom.from, to: custom.to }
  }
  if (period === 'LFY') {
    const fsm = fiscalStartMonth && fiscalStartMonth >= 1 && fiscalStartMonth <= 12 ? fiscalStartMonth : 1
    const todayYear = today.getFullYear()
    const todayMonth = today.getMonth() + 1
    let anchorYear = todayYear
    if (todayMonth < fsm) anchorYear = todayYear - 1
    const startYear = anchorYear - 1
    const start = new Date(startYear, fsm - 1, 1)
    const end = new Date(startYear + 1, fsm - 1, 0)
    return { from: isoDate(start), to: isoDate(end) }
  }
  const end = new Date(today)
  const start = new Date(today)
  switch (period) {
    case '3M': start.setMonth(end.getMonth() - 3); break
    case '6M': start.setMonth(end.getMonth() - 6); break
    case '1Y': start.setFullYear(end.getFullYear() - 1); break
    default:   start.setMonth(end.getMonth() - 1); break
  }
  return { from: isoDate(start), to: isoDate(end) }
}
